const sortByPositionAndId = (a, b) => {
  const positionA = Number(a?.position ?? 0);
  const positionB = Number(b?.position ?? 0);

  if (positionA !== positionB) {
    return positionA - positionB;
  }

  return Number(a?.id ?? 0) - Number(b?.id ?? 0);
};

const toIdString = value => {
  if (value === undefined || value === null || value === '') {
    return null;
  }

  return value.toString();
};

const getSectionId = section => toIdString(section?.id);

const getSwimlaneSectionId = swimlane => {
  const section = swimlane?.section;

  if (section === undefined || section === null || section === '') {
    return null;
  }

  return toIdString(section?.id ?? section);
};

const toSummarySwimlaneRow = (swimlane, renderSwimlane) => ({
  rowData: swimlane,
  type: 'swimlane',
  renderMethod: renderSwimlane,
});

export const buildTopLevelSectionSummaryRows = ({
  budgetData,
  renderSwimlane,
  renderSection,
}) => {
  const swimlanes = Array.isArray(budgetData?.budget_swimlane)
    ? [...budgetData.budget_swimlane].sort(sortByPositionAndId)
    : [];
  const sections = Array.isArray(budgetData?.top_level_sections)
    ? [...budgetData.top_level_sections].sort(sortByPositionAndId)
    : [];

  if (!sections.length) {
    return swimlanes.map(swimlane =>
      toSummarySwimlaneRow(swimlane, renderSwimlane)
    );
  }

  const rows = [];
  const renderedSwimlaneIds = new Set();

  sections.forEach(section => {
    const sectionId = getSectionId(section);
    const sectionSwimlanes = swimlanes.filter(
      swimlane => getSwimlaneSectionId(swimlane) === sectionId
    );

    if (!sectionSwimlanes.length) {
      return;
    }

    sectionSwimlanes.forEach(swimlane => {
      rows.push(toSummarySwimlaneRow(swimlane, renderSwimlane));
      renderedSwimlaneIds.add(toIdString(swimlane?.id));
    });

    rows.push({
      rowData: {
        ...section,
        cost: sectionSwimlanes.reduce(
          (sum, swimlane) => sum + parseFloat(swimlane?.cost || 0),
          0
        ),
      },
      type: 'topLevelSection',
      renderMethod: renderSection,
    });
  });

  swimlanes
    .filter(swimlane => !renderedSwimlaneIds.has(toIdString(swimlane?.id)))
    .forEach(swimlane => {
      rows.push(toSummarySwimlaneRow(swimlane, renderSwimlane));
    });

  return rows;
};
